<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.tr_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.tr_fullname" prop>
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['ho_ten.ho_ten']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                   <b-col md="3">
                    <el-form-item :label="aLang.tr_card_number" prop>
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['so_the']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.tr_phone" prop>
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['dien_thoai']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ho_ten.ho_ten"
            :label="aLang.tr_fullname"
            min-width="180"
          >
          </el-table-column>
          <el-table-column
            prop="so_the"
            :label="aLang.tr_card_number"
            min-width="140"
            align="center"
          >
            <template slot-scope="scope" v-if="scope.row">
              {{scope.row.so_the && scope.row.so_the.slice(0,2) && scope.row.so_the.length == 11? '' : scope.row.so_the}}
            </template>
          </el-table-column>
          <el-table-column
            prop="gioi_tinh"
            :label="aLang.tr_gender"
            width="100"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="ngay_sinh.ngay_sinh"
            :label="aLang.tr_bod"
            :formatter="fn_formatterDate"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="email"
            :label="aLang.tr_email"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="dien_thoai"
            :label="aLang.tr_phone"
            width="120"
            align="right"
          >
            <template slot-scope="scope" v-if="scope.row">
              {{scope.row.so_the && scope.row.so_the.slice(0,2) && scope.row.so_the.length == 11 ? scope.row.so_the : scope.row.dien_thoai}}
            </template>
          </el-table-column>
          <el-table-column
            prop="star"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tr_evaluate"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.star,1)}}
            </template>
          </el-table-column>
           <el-table-column
            prop="count"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.tr_number_of_evaluate"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.count,0)}}
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="80px">
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>             -->
              <el-button
                size="mini"
                @click="fn_goDanhGia('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="'Xem đánh giá'"
              >
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">

            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total,sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DanhGiaKDLModel from "./DanhGiaKDLModel";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";

export default {
  data() {
    return {
      aRole:MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGiaKDL", //requied
        tableRules:  MethodService.copyObject(DanhGiaKDLModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: [],
          listKDL: [],
          listStar: []
        }
      }
    };
  },

  methods: {
    //get list table
    // async fn_initTable() {
    //   let dataFilter = {
    //     filters: this.mData.tableRules.filters
    //   };

    //   if (this.mData.tableRules.allowPaging) {
    //     dataFilter.limit = this.mData.tableRules.limit;
    //     dataFilter.offset = this.mData.tableRules.offset;
    //   }
    //   if (this.mData.tableRules.allowSorting) {
    //     dataFilter.sort = this.mData.tableRules.sort;
    //   }

    //   if (this.mData.tableRules.showUrl) {
    //     this.$router.replace({
    //       name: "Admin-" + this.mData.moduleName + "-list",
    //       query: {
    //         limit: this.mData.tableRules.limit,
    //         page: this.mData.tableRules.page,
    //         sort: this.mData.tableRules.sort,
    //         filters: this.mData.tableRules.filters,
    //         showFormSearch: this.mData.tableRules.showFormSearch
    //       }
    //     });
    //   }

    //   let res = await KhachDuLichApi.list(dataFilter);

    //    let doiTuongDanhGias = MethodService.findListItemDifferent(
    //     res.result,
    //     "id"
    //   );
    //   let resStar=await DanhGiaApi.getStar(doiTuongDanhGias);
    //   this.mData.dataDefault.listStar=resStar.result;
    //   // debugger

    //   this.mData.tableRules.data = this.changeData(res.result);
    //   this.mData.tableRules.total = res.meta.total;
    //   this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
    //   if (
    //     this.mData.tableRules.offset == res.meta.total &&
    //     this.mData.tableRules.offset != 0
    //   ) {
    //     this.mData.tableRules.offset = 0;
    //     this.mData.tableRules.page = 1;
    //     this.fn_initTable();
    //   }
    // },

    // //xử lý dữ liệu đầu ra
    // changeData(data) {
    //   $.each(data, (index, item) => {
    //     if (item.gioi_tinh != undefined) {
    //       let gt = DataService.gioiTinh.find(element => {
    //         return element.id == item.gioi_tinh;
    //       });
    //       if (gt) {
    //         item.gioi_tinh = gt.text;
    //       }
    //     }

    //     if (item.ngay_sinh != undefined) {
    //       item.ngay_sinh.ngay_sinh = new Date(
    //         item.ngay_sinh.nam,
    //         item.ngay_sinh.thang - 1,
    //         item.ngay_sinh.ngay
    //       ).toUTCString();
    //     }

    //     let resFind=this.mData.dataDefault.listStar.find(
    //       element => {
    //         return element.id == item.id;
    //       }
    //     );
    //     if (resFind) {
    //       item.so_sao = resFind.star;
    //     }
    //     else {
    //       item.so_sao = "";
    //     }
    //   });
    //   return data;
    // },
    removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    changeName (str){
      if (!str) {
        return "";
      }
      return this.removeAccents(str.toLowerCase()).split(' ').join(',')
    },
    changePhoneNumber(number){
      if (!number) {
        return "";
      }
      if(number.substr(0, 1) == '+' || number.substr(0, 1) == '0' ){
        return number.substr(1)
      }
      return number
    },
    async fn_initTable() {
      let ho_ten =  this.mData.tableRules.dataSearch.value['ho_ten.ho_ten']
      let dataFilter = {
        filter: this.mData.tableRules.filters,
        words: this.changeName(ho_ten),
        so_the : this.mData.tableRules.dataSearch.value['so_the'],
        dien_thoai : this.changePhoneNumber(this.mData.tableRules.dataSearch.value['dien_thoai'])
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
         dataFilter.sort_type = this.mData.tableRules.sort_type;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            // words: this.mData.tableRules.words,
            filters: this.mData.tableRules.filters
          }
        });
      }

      let res=await DanhGiaApi.getSortableStarForTourist(dataFilter);
      // let res1=await DanhGiaApi.getSortableStarForTourist();
      // let res2=await DanhGiaApi.getSortableStarForTouristTotal();
      let doiTuongDanhGias = await MethodService.findListItemDifferent(
        res.result,
        "doi_tuong_id"
      );

      let resKDL = await KhachDuLichApi.list({limit:1000, filters:"id:in:"+doiTuongDanhGias.join(',')});
      this.mData.dataDefault.listKDL=resKDL.result;


      this.mData.tableRules.data = this.changeData(res.result);

      let resTotal = await DanhGiaApi.getSortableStarForTouristTotal(dataFilter);
      // let resultResTotal = await resTotal.result;
      // this.mData.tableRules.total = resultResTotal[0] ? resultResTotal[0].total :0;
      this.mData.tableRules.total = resTotal.result.length ? resTotal.result[0].total : 0;
      // this.mData.tableRules.total = res.meta.total;
      // this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      // if (
      //   this.mData.tableRules.offset == res.meta.total &&
      //   this.mData.tableRules.offset != 0
      // ) {
      //   this.mData.tableRules.offset = 0;
      //   this.mData.tableRules.page = 1;
      //   this.fn_initTable();
      // }

      // debugger;
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        let resFind=this.mData.dataDefault.listKDL.find(
          element => {
            return element.id == item.doi_tuong_id;
          }
        );
        if (resFind) {
          item.so_the = resFind.so_the;
          item.ho_ten = resFind.ho_ten;
          if(resFind.ho_ten && resFind.ho_ten.ho_ten && resFind.ho_ten.ho_ten.trim() != ""){
            item.ho_ten.ho_ten = resFind.ho_ten.ho_ten;
          }else{
            item.ho_ten ={
              ho_ten : "Chưa có thông tin" 
            } 
          }
          item.email=resFind.email;
          item.dien_thoai=resFind.dien_thoai;
          item.gioi_tinh=resFind.gioi_tinh;
          item.ngay_sinh=resFind.ngay_sinh;
          item.giay_to=resFind.giay_to;
          item.quoc_tich=resFind.quoc_tich;
          item.dia_chi=resFind.dia_chi;
          item.avatar_id=resFind.avatar_id;
        } else {
          item.so_the = MethodService.copyObject(DanhGiaKDLModel.dataForm.so_the);
          item.ho_ten=MethodService.copyObject(DanhGiaKDLModel.dataForm.ho_ten);
          item.email=MethodService.copyObject(DanhGiaKDLModel.dataForm.email);
          item.dien_thoai=MethodService.copyObject(DanhGiaKDLModel.dataForm.dien_thoai);
          item.gioi_tinh=MethodService.copyObject(DanhGiaKDLModel.dataForm.gioi_tinh);
          item.ngay_sinh=MethodService.copyObject(DanhGiaKDLModel.dataForm.ngay_sinh);
          item.giay_to=MethodService.copyObject(DanhGiaKDLModel.dataForm.giay_to);
          item.quoc_tich=MethodService.copyObject(DanhGiaKDLModel.dataForm.quoc_tich);
          item.dia_chi=MethodService.copyObject(DanhGiaKDLModel.dataForm.dia_chi);
          item.avatar_id=MethodService.copyObject(DanhGiaKDLModel.dataForm.avatar_id);
        }

        if (item.gioi_tinh != undefined) {
          let gt = DataService.gioiTinh.find(element => {
            return element.id == item.gioi_tinh;
          });
          if (gt) {
            item.gioi_tinh = gt.text;
          }
        }

        if (item.ngay_sinh != undefined) {
          item.ngay_sinh.ngay_sinh = new Date(
            item.ngay_sinh.nam,
            item.ngay_sinh.thang - 1,
            item.ngay_sinh.ngay
          ).toUTCString();
        }

      });
      return data;
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await KhachDuLichApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await KhachDuLichApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value['ho_ten.ho_ten']){
        this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'] = this.mData.tableRules.dataSearch.value['ho_ten.ho_ten'].trim();
      }
      if(this.mData.tableRules.dataSearch.value['so_the']){
        this.mData.tableRules.dataSearch.value['so_the'] = this.mData.tableRules.dataSearch.value['so_the'].trim();
      }
      if(this.mData.tableRules.dataSearch.value['dien_thoai']){
        this.mData.tableRules.dataSearch.value['dien_thoai'] = this.mData.tableRules.dataSearch.value['dien_thoai'].trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_goDanhGia(type, scope, row) {
      if (type == "detail") {
        localStorage.setItem('prevUrl', this.$router.currentRoute.path);

        this.$router.push({
          name: "Admin-DanhGiaKDLDetail-list",
          query: {
            filters: "loai_doi_tuong_danh_gia=tourist&doi_tuong_danh_gia_id=" + row.doi_tuong_id,
            doi_tuong_danh_gia_id: row.doi_tuong_id,
            loai_doi_tuong_danh_gia:  'tourist'
          },
          // params: {
          //   benh_id: row.id
          // }
        });
      }
    },

    fn_formatterNumber(cellValue, dec) {
      if (typeof cellValue == "number") {
        if (!(dec && typeof cellValue == "number")) dec = 0;
        return cellValue
          .toFixed(dec)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
      }
    },


    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
